import React, { useState } from 'react';
import './userProfileAttendanceDetailsV3.css'
const addIcon = require("../../Assets/userManagementV3/Add.png").default;
const hoverAddIcon = require("../../Assets/userManagementV3/onHoverAdd.png").default;

const ADDGeofenceCardV3 = ({setLocationDrawerVisible, locationDrawerVisible, getHolidays, params, geoFence}) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div className='geofence-card-container'>
      <div
        className={`geofence-card ${isHovered ? 'hovered' : ''}`}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)} 
        onClick={()=>{setLocationDrawerVisible(true)}}
      >
        <div className='geofence-card-content'>
          <div>
            <div className='geofence-card-icon'>
              <img src={isHovered ? hoverAddIcon : addIcon} alt="Add Icon" />
            </div>
            <div className='geofence-card-text'> ADD A NEW GEOFENCE</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ADDGeofenceCardV3;
